/*
The axios instance for the front end
 */

import axios from "axios";

const api = axios.create({
  baseURL: '/wp-json/rider/v1',
  headers: {
    'Content-Type': 'application/json',
    'X-WP-Nonce': rider.nonces.wp,
  },
});

api.interceptors.request.use((config) => {
  if (config.method === 'post') {
    config.data.riderNonce = rider.nonces.nonce;
  }
  if (config.method === 'get') {
    config.params = config.params || {};
    config.params.riderNonce = rider.nonces.nonce;
  }
  return config;
});

api.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  console.error(error.response)
  if ([401, 403].includes(error.response.status)) {
    alert(`Un temps d'inaction trop long est détecté. Par sécurité merci de recharger la page.`);
  } else {
    alert(`Un problème est survenu. Nous sommes désolé pour la gêne occasionnée.`);
  }
  return Promise.reject(error);
});

export default api;
